// UGM отдаёт цену строкой ("125000.00") или пустой строкой, если цена по запросу
export function formatPrice(price) {
	const value = parseFloat(price)
	if (!price || Number.isNaN(value)) return 'Price on request'
	return value.toLocaleString('en-US', { maximumFractionDigits: 2 })
}
